var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM8.75 8C8.75 7.78668 8.82016 7.45002 9.00865 7.18823C9.1696 6.96468 9.44444 6.75 10 6.75C10.5556 6.75 10.8304 6.96468 10.9913 7.18823C11.1798 7.45002 11.25 7.78668 11.25 8C11.25 8.21332 11.1798 8.54998 10.9913 8.81177C10.8304 9.03532 10.5556 9.25 10 9.25C9.58579 9.25 9.25 9.58579 9.25 10V11.5C9.25 11.9142 9.58579 12.25 10 12.25C10.4142 12.25 10.75 11.9142 10.75 11.5V10.6636C11.4019 10.5045 11.8837 10.1396 12.2087 9.68823C12.6202 9.11668 12.75 8.45335 12.75 8C12.75 7.54665 12.6202 6.88332 12.2087 6.31177C11.7696 5.70198 11.0444 5.25 10 5.25C8.95556 5.25 8.2304 5.70198 7.79135 6.31177C7.37984 6.88332 7.25 7.54665 7.25 8C7.25 8.41421 7.58579 8.75 8 8.75C8.41421 8.75 8.75 8.41421 8.75 8ZM10.75 14C10.75 14.4142 10.4142 14.75 10 14.75C9.58579 14.75 9.25 14.4142 9.25 14C9.25 13.5858 9.58579 13.25 10 13.25C10.4142 13.25 10.75 13.5858 10.75 14Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpBlack);
export default __webpack_public_path__ + "static/media/help-black.74684690ab0b3d85b146d252085fb958.svg";
export { ForwardRef as ReactComponent };